import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { getCheckoutStatus } from "../lib/api";

export default function SuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: "unpaid" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) {
      setState({ status: "error", payment_status: "missing" });
      return;
    }

    let cancelled = false;
    let timer;

    const poll = async (n = 0) => {
      if (cancelled) return;
      if (n >= 6) {
        setState({ status: "timeout", payment_status: "unknown" });
        return;
      }
      try {
        const data = await getCheckoutStatus(sessionId);
        if (cancelled) return;
        setAttempts(n + 1);
        if (data.payment_status === "paid") {
          setState({ status: "paid", payment_status: "paid", ...data });
          const purchaseValue = typeof data.amount_total === "number" ? data.amount_total / 100 : 29.90;
          // Meta Pixel: Purchase event (only fires once, when payment is confirmed)
          if (typeof window !== "undefined" && window.fbq) {
            window.fbq("track", "Purchase", {
              value: purchaseValue,
              currency: "EUR",
              content_name: "Workbook — Quando já não dá para continuar igual",
              content_ids: ["workbook-anabela-reis"],
              content_type: "product",
            });
          }
          // Google Ads conversion event (only fires once, when payment is confirmed)
          if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("event", "conversion", {
              send_to: "AW-18332600248/ix_0CLCfttIcELiP1aVE",
              value: purchaseValue,
              currency: "EUR",
              transaction_id: sessionId,
            });
          }
          return;
        }
        if (data.status === "expired") {
          setState({ status: "expired", payment_status: "expired" });
          return;
        }
        timer = setTimeout(() => poll(n + 1), 2000);
      } catch (e) {
        timer = setTimeout(() => poll(n + 1), 2500);
      }
    };

    poll(0);
    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [sessionId]);

  return (
    <main data-testid="success-page" className="min-h-screen bg-cream flex items-center justify-center px-6 py-24">
      <div className="max-w-2xl w-full text-center">
        {state.status === "paid" ? (
          <>
            <p className="smallcaps text-accent mb-8">Compra confirmada</p>
            <h1 className="font-serif-display text-4xl md:text-6xl text-ink leading-[1.05] mb-10">
              Obrigada.<br />
              <em className="text-accent font-normal">O teu workbook está a caminho.</em>
            </h1>
            <p className="text-lg text-ink-soft leading-relaxed mb-12">
              Vais receber o PDF no teu email dentro de momentos. Se não chegar
              dentro de 10 minutos, verifica a pasta de spam ou escreve para{" "}
              <a href="mailto:info@anabelareisconsultoria.pt" className="text-accent underline">
                info@anabelareisconsultoria.pt
              </a>.
            </p>
            <blockquote className="font-serif-display italic text-2xl text-ink border-t border-b border-[#e6e2dc] py-8 mb-12">
              "Um passo, só um. <br />É assim que tudo começa."
            </blockquote>
            <Link
              to="/"
              data-testid="back-home-link"
              className="btn-ghost inline-block px-10 py-4 rounded-sm uppercase text-sm"
            >
              Voltar à página
            </Link>
          </>
        ) : state.status === "checking" ? (
          <>
            <div className="flex justify-center mb-8">
              <div className="w-12 h-12 border border-[#a75a4c] border-t-transparent rounded-full animate-spin" />
            </div>
            <h1 className="font-serif-display text-3xl md:text-5xl text-ink mb-6">
              A confirmar o teu pagamento…
            </h1>
            <p className="text-ink-soft">Tentativa {attempts + 1} de 6 — não feches esta janela.</p>
          </>
        ) : (
          <>
            <h1 className="font-serif-display text-3xl md:text-5xl text-ink mb-6">
              Estamos a verificar o teu pagamento.
            </h1>
            <p className="text-ink-soft mb-10">
              Se já concluíste o pagamento, vais receber um email em breve. Em caso
              de dúvida, escreve-nos.
            </p>
            <Link to="/" className="btn-ghost inline-block px-10 py-4 rounded-sm uppercase text-sm">
              Voltar à página
            </Link>
          </>
        )}
      </div>
    </main>
  );
}
